import React, { useContext, useEffect, useState } from "react";
import { View, TouchableOpacity, TextInput } from "react-native";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import Wrapper from "../../components/wrapper";
import InnerBox from "../../components/inner-box";
import InnerBoxTitle from "../../components/inner-box-title";
import CustomButton from "../../components/button";
import LoginContext from "../../hooks/loginContext";
import { getUserInfo } from "../../utils/user";
import translations from '../../utils/translations.json';
import { TranslateText } from "../../components/translate-text";

const LoginScreen = ({ setIndex }) => {
  let defaultForm = {
    email: "",
    password: "",
  }
  if (process.env.NODE_ENV ==   "development") {
    defaultForm = {
      email: "test5@hollo.hk",
      password: "testhollo",
    }
  }
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState(defaultForm);
  const { setUser } = useContext(LoginContext);

  const loginUser = () => {
    setLoading(true);
    const auth = getAuth();
    signInWithEmailAndPassword(auth, form.email, form.password)
    .then(async (res) => {
      const user = await getUserInfo(res.user.uid);
      if(user.fullname !== '') {
        setUser(user);
        localStorage.setItem('user', JSON.stringify(user));
        setIndex(3);
      } else {
        setUser({id: res.user.uid});
        setIndex(1);
      }
      })
      .catch((error) => {
        if (error.code === "auth/email-already-in-use") {
          alert("That email address is already in use!");
        }
        if (error.code === "auth/invalid-email") {
          alert("Invalid login or password. Please try again");
        } else {
          alert("Invalid login or password. Please try again");
        }
      });
    setLoading(false);
  };

  console.log(translations);

  return (
    <Wrapper>
      <TranslateText
        style={{
          fontSize: 28,
          marginVertical: 8,
          position: "absolute",
          top: 60,
        }}
      >
        Hollo DigiACT
      </TranslateText>
      <InnerBox>
        <InnerBoxTitle
          title={translations["Login"]}
          subtitle={
            translations["Welcome to the Clinical Trial of Hollo’s Digi-ACT. Please login using the Password in your email."]
          }
        />
        <View
          style={{
            flexDirection: "column",
            justifyContent: "space-between",
            width: "100%",
            flex: 1,
          }}
        >
          <View
            style={{
              flexDirection: "column",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <View
              style={{
                marginVertical: 16,
                width: "100%",
                paddingHorizontal: 40,
              }}
            >
              <TranslateText style={{ fontSize: 20 }}>{translations["Username"]}</TranslateText>
              <TextInput
                placeholder={translations["Username"]}
                style={{
                  borderBottomWidth: 1,
                  padding: 12,
                  color: "#000",
                  placeholder: { color: "#000" },
                  marginVertical: 8,
                  flex: 1,
                }}
                value={form.email}
                onChangeText={(email) => {
                  setForm({ ...form, email });
                }}
                placeholderTextColor="#7A7A7A"
              />
            </View>
            <View
              style={{
                marginVertical: 8,
                width: "100%",
                paddingHorizontal: 40,
              }}
            >
              <TranslateText style={{ fontSize: 20 }}>{translations["Password"]}</TranslateText>
              <View>
                <TextInput
                  secureTextEntry={true}
                  placeholder={translations["Password"]}
                  style={{
                    borderBottomWidth: 1,
                    padding: 12,
                    color: "#000",
                    placeholder: { color: "#000" },
                    marginVertical: 8,
                    flex: 1,
                    justifyContent: "space-between",
                  }}
                  value={form.password}
                  placeholderTextColor="#7A7A7A"
                  onChangeText={(password) => {
                    setForm({ ...form, password });
                  }}
                />
              </View>
            </View>
          </View>
          <CustomButton
            title={translations["Log in"]}
            onPress={loginUser}
            loading={loading}
          />
        </View>
      </InnerBox>
    </Wrapper>
  );
};

export default LoginScreen;
